import { render, staticRenderFns } from "./Photography.vue?vue&type=template&id=fce8e242"
import script from "./Photography.vue?vue&type=script&lang=ts"
export * from "./Photography.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports